import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import styled from "styled-components";
import OrderController from "../../controller/OrderController";
import { KnockOrderItemType } from "../../recoil/type";
import "../../styles/CustomModal.css";

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  props: KnockOrderItemType;
  minute: number;
  updateStatus: any;
  estimatedTime: number;
  setEstimatedTime: any;
};

interface DeliveryTimeProps {
  time: number;
  onClick: () => void;
  isActive: boolean;
}

const DeliveryTime: React.FC<DeliveryTimeProps> = ({
  time,
  onClick,
  isActive,
}) => {
  return (
    <div
      className={`deliveryItem ${isActive ? "active" : ""}`}
      onClick={onClick}
    >
      {time}분
    </div>
  );
};
const PickupTimeModal = ({
  isVisible,
  setVisible,
  props,
  minute,
  updateStatus,
  estimatedTime,
  setEstimatedTime,
}: Props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedTime, setSelectedTime] = useState<number | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const onCloseModal = () => {
    setVisible(false);
    // console.log("containerRef", containerRef);
  };

  // API 연결
  const updateDeliveryInfo = async (clickedTime: number) => {
    try {
      let oRes = await OrderController.updateDeliveryInfo(
        props.store_id,
        minute
      );
      console.log("updateDeliveryInfo", oRes, minute, clickedTime);
      if (oRes && oRes.data && oRes.data.ok) {
        updateStatus(clickedTime);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  // 픽업시간 설정
  const deliveryTime = Array.from(
    { length: (90 - 15) / 5 + 1 },
    (_, index) => 15 + index * 5
  );
  const showDeliveryTime = () => {
    return deliveryTime
      .slice(currentIndex, currentIndex + 3)
      .map((time, index) => (
        <DeliveryTime
          key={index}
          time={time}
          onClick={() => handleTimeClick(time)}
          isActive={time === selectedTime}
        />
      ));
  };
  const move = (direction: number) => {
    const newIndex = currentIndex + direction * 3;
    setCurrentIndex(Math.max(0, Math.min(newIndex, deliveryTime.length - 3)));
    scrollToIndex(newIndex);
  };
  const scrollToIndex = (index: number) => {
    if (containerRef.current) {
      const scrollAmount = index * (containerRef.current.clientWidth / 3);
      containerRef.current.scrollLeft = scrollAmount;
    }
  };
  const handleTimeClick = (clickedTime: number) => {
    // 선택한 준비시간
    // console.log("clickedTime~~~~~~~", clickedTime);
    setEstimatedTime(clickedTime);
    setSelectedTime(clickedTime);
    updateDeliveryInfo(clickedTime);
    setVisible(false);
  };
  useEffect(() => {
    // 모달이 열릴 때마다 초기 준비시간 값 설정
    if (isVisible) {
      setSelectedTime(null);
      const centerIndex = deliveryTime.indexOf(minute);
      if (centerIndex !== -1) {
        const initialIndex = Math.max(0, centerIndex - 1);
        setCurrentIndex(initialIndex);
        scrollToIndex(initialIndex);
      }
    }
  }, [isVisible]);

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "pickupTimeModalOverlay",
        modal: "pickupTimeModal",
      }}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
          alt="ic"
        />
      }
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div className="modalWrap">
          <div className="closeWrap">
            <button onClick={onCloseModal} className="closeModal">
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close_white.svg`}
                alt="모달 닫기 버튼"
              />
              닫기
            </button>
          </div>
          {props.child.delivery_type === 0 ? (
            <>
              <h2>준비완료 예정시간</h2>
              <h3>배달기사 픽업이 요청 시간을 선택해주세요</h3>
            </>
          ) : (
            <>
              <h2>배달 도착 시간</h2>
              <h3>고객님께 도착할 예정 시간을 선택해주세요</h3>
            </>
          )}
          <div className="pickupTimeList">
            <button onClick={() => move(-1)}>
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_left.svg`}
                alt="왼쪽 이동 버튼"
              />
            </button>
            <div className="itemWrap">{showDeliveryTime()}</div>
            <button onClick={() => move(1)}>
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_right.svg`}
                alt="오른쪽 이동 버튼"
              />
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default PickupTimeModal;

const Style = styled.div`
  .modalWrap {
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  h2 {
    font-size: 32px;
    font-weight: 600;
  }
  h3 {
    margin: 22px 0;
    font-size: 24px;
    font-weight: 500;
  }
  button {
    cursor: pointer;
  }

  /* closeWrap */
  .closeWrap {
    width: 60vw;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 13px;
  }
  .closeModal {
    display: flex;
    align-items: center;
    border: 1px solid #fff;
    border-radius: 10px;
    padding: 8px 8px 6px 8px;
    color: #fff;

    img {
      width: 20px;
      margin-right: 6px;
    }
  }

  /* slider */
  .pickupTimeList {
    width: 65vw;
    max-width: 900px;
    margin-bottom: 54px;
    display: flex;
    justify-content: center;
    justify-content: space-between;

    .itemWrap {
      display: flex;
    }
    .deliveryItem {
      width: 190px;
      height: 190px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 5px;
      border-radius: 20px;
      font-size: 32px;
      font-weight: 500;
      color: #4dd2ae;
    }
  }
  .deliveryItem.active {
    background: #4dd2ae;
    color: #fff;
  }

  .deliveryItem:hover {
    filter: brightness(0.9);
  }

  /* selfDelivery */
  .selfDeliveryButton {
    width: 48vw;
    max-width: 610px;
    padding: 21px;
    border-radius: 15px;
    background: #fff;
    font-size: 32px;
    font-weight: 500;
    color: #4dd2ae;
  }
`;
